import React from 'react'

const AdminChefTicketList = () => {
    return (
        <h2>Ticket List</h2>
    )
}

export default AdminChefTicketList
